// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restore-activities-dialog {
  z-index: 1000000 !important;
}

.restore-activities-dialog .k-dialog {
  width: 480px;
  max-width: calc(100vw - 32px);
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.restore-activities-dialog .k-dialog-content {
  padding: 0;
}

.restore-activities-card {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
  padding: 0;
  background: #fff;
}

.restore-activities-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.restore-activities-close img {
  display: block;
  width: 20px;
  height: 20px;
}

.restore-activities-image {
  display: block;
}

.restore-activities-image img {
  display: block;
  width: 100%;
  height: auto;
}

.restore-activities-content {
  padding: 30px 30px 0;
  text-align: center;
}

.restore-activities-content h2 {
  margin: 0 0 12px;
  color: #1f1f1f;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
}

.restore-activities-content p {
  margin: 0;
  color: #525252;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}

.restore-activities-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
  padding: 15px 30px;
  border-top: 1px solid #dadada;
}

.restore-activities-button {
  height: 36px;
  padding: 0 16px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}

.restore-activities-button-secondary {
  border: 1px solid var(--kendo-color-border, #d9d9d9);
  background: #fff;
  color: #333;
}

.restore-activities-button-primary {
  border: 1px solid #333;
  background: #333;
  color: #fff;
}

.restore-activities-button-primary:hover {
  background: #1f1f1f;
}

.mobile-restore-activities-dialog .restore-activities-card {
  padding: 0;
}

.mobile-restore-activities-dialog .restore-activities-close {
  top: 12px;
  right: 12px;
}

.mobile-restore-activities-dialog .restore-activities-image {
  display: block;
  margin: 0;
}

.mobile-restore-activities-dialog .restore-activities-footer {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  margin-top: 16px;
}

.mobile-restore-activities-dialog .restore-activities-button {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/css/RestoreActivitiesDialog.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oDAAoD;EACpD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".restore-activities-dialog {\n  z-index: 1000000 !important;\n}\n\n.restore-activities-dialog .k-dialog {\n  width: 480px;\n  max-width: calc(100vw - 32px);\n  padding: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.restore-activities-dialog .k-dialog-content {\n  padding: 0;\n}\n\n.restore-activities-card {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0;\n  background: #fff;\n}\n\n.restore-activities-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.restore-activities-close img {\n  display: block;\n  width: 20px;\n  height: 20px;\n}\n\n.restore-activities-image {\n  display: block;\n}\n\n.restore-activities-image img {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.restore-activities-content {\n  padding: 30px 30px 0;\n  text-align: center;\n}\n\n.restore-activities-content h2 {\n  margin: 0 0 12px;\n  color: #1f1f1f;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.restore-activities-content p {\n  margin: 0;\n  color: #525252;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n}\n\n.restore-activities-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 20px;\n  padding: 15px 30px;\n  border-top: 1px solid #dadada;\n}\n\n.restore-activities-button {\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 40px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n.restore-activities-button-secondary {\n  border: 1px solid var(--kendo-color-border, #d9d9d9);\n  background: #fff;\n  color: #333;\n}\n\n.restore-activities-button-primary {\n  border: 1px solid #333;\n  background: #333;\n  color: #fff;\n}\n\n.restore-activities-button-primary:hover {\n  background: #1f1f1f;\n}\n\n.mobile-restore-activities-dialog .restore-activities-card {\n  padding: 0;\n}\n\n.mobile-restore-activities-dialog .restore-activities-close {\n  top: 12px;\n  right: 12px;\n}\n\n.mobile-restore-activities-dialog .restore-activities-image {\n  display: block;\n  margin: 0;\n}\n\n.mobile-restore-activities-dialog .restore-activities-footer {\n  flex-direction: column;\n  margin-top: 16px;\n}\n\n.mobile-restore-activities-dialog .restore-activities-button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
